<template>
  <div id="deliveryRecord">
    <div class="hr_container">
      <div class="hr_index">
        <div class="hr_img">
          <img src="../../../assets/hr/banner_img.png" alt="">
        </div>
      </div>
      <van-tabs v-model="active">
        <van-tab title="内推">
          <div class="tab_list">
            <div class="tab_item" v-for="(list, index) in inList" :key="index" @click="jumpPageDetail(list.recordUuid,1)">
              <div class="tab_item_top tab_item_line_height">
                <div class="picture">
                  <img :src="list.imgUrl" alt="" />
                </div>
                <div class="tite_in">{{ list.name }}</div>
                <!-- <div class="time">投递时间：{{ list.time }}</div> -->
                <div class="time">
                  <img src="../../../assets/hr/detail_icon.png" alt="">
                </div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">投递时间：</div>
                <div class="info_right">{{ list.createTime }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">应聘岗位：</div>
                <div class="info_right">{{ list.positionName }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">应聘部门：</div>
                <div class="info_right">{{ list.deptName }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">联系电话：</div>
                <div class="info_right setColor" @click.stop="callPhone(list.tel)">{{ list.tel }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">邮 箱：</div>
                <div class="info_right" ref="select" @click="sendEmail(list.email)">
                  {{ list.email }}
                </div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">推 荐 人：</div>
                <div class="info_right">{{ list.operatorName }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">关 系：</div>
                <div class="info_right">{{ list.relation }}</div>
              </div>
              <div class="tab_item_info" v-if="list.interviewResult != 0">
                <div class="info_left" v-if="list.hrEmpName">操 作 人：</div>
                <div class="info_right">
                  <div  v-if="list.interviewResult == 1">
                    {{list.hrEmpName}}  <img src="../../../assets/user/query.png" alt="">
                  </div>
                  <div  v-if="list.interviewResult == 2">
                    {{list.hrEmpName}}  <img src="../../../assets/user/no.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="自荐">
          <div class="tab_list">
            <div class="tab_item" v-for="(list, index) in selfList" :key="index" @click="jumpPageDetail(list.recordUuid,1)">
              <div class="tab_item_top">
                <div class="picture">
                  <img :src="list.imgUrl" alt="" />
                </div>
                <div class="text_self">
                  <div class="tite_self">{{ list.name }}</div>
                  <div class="content">{{ list.department }}</div>
                </div>
                <!-- <div class="time time_margin_top">投递时间：{{ list.time }}</div> -->
                <div class="time time_margin_top">
                  <img src="../../../assets/hr/detail_icon.png" alt="">
                </div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">投递时间：</div>
                <div class="info_right">{{ list.createTime }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">应聘岗位：</div>
                <div class="info_right">{{ list.positionName }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">应聘部门：</div>
                <div class="info_right">{{ list.deptName }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">联系电话：</div>
                <div class="info_right setColor" @click.stop="callPhone(list.tel)">{{ list.tel }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">邮 箱：</div>
                <div class="info_right" @click="sendEmail(list.email)">{{ list.email }}</div>
              </div>
              <div class="tab_item_info" v-if="list.interviewResult != 0">
                <div class="info_left" v-if="list.hrEmpName">操 作 人：</div>
                <div class="info_right">
                  <div  v-if="list.interviewResult == 1">
                    {{list.hrEmpName}} <img src="../../../assets/user/query.png" alt="">
                  </div>
                  <div  v-if="list.interviewResult == 2">
                    {{list.hrEmpName}} <img src="../../../assets/user/no.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="已处理">
          <div class="tab_list">
            <div class="tab_item" v-for="(list, index) in handleList" :key="index" @click="jumpPageDetail(list.recordUuid,2)">
              <div class="tab_item_top">
                <div class="picture">
                  <img :src="list.imgUrl" alt="" />
                </div>
                <div class="text_self">
                  <div class="tite_self">{{ list.name }}</div>
                  <div class="content">{{ list.department }}</div>
                </div>
                <!-- <div class="time time_margin_top">投递时间：{{ list.time }}</div> -->
                <div class="time time_margin_top">
                  <img src="../../../assets/hr/detail_icon.png" alt="">
                </div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">投递时间：</div>
                <div class="info_right">{{ list.createTime }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">应聘岗位：</div>
                <div class="info_right">{{ list.positionName }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">应聘部门：</div>
                <div class="info_right">{{ list.deptName }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">联系电话：</div>
                <div class="info_right setColor" @click.stop="callPhone(list.tel)">{{ list.tel }}</div>
              </div>
              <div class="tab_item_info">
                <div class="info_left">邮 箱：</div>
                <div class="info_right" @click="sendEmail(list.email)">{{ list.email }}</div>
              </div>
              <div class="tab_item_info" v-if="list.operatorName">
                <div class="info_left">推 荐 人：</div>
                <div class="info_right">{{ list.operatorName }}</div>
              </div>
              <div class="tab_item_info" v-if="list.relation">
                <div class="info_left">关 系：</div>
                <div class="info_right">{{ list.relation }}</div>
              </div>
              <div class="tab_item_info" v-if="list.interviewResult != 0">
                <div class="info_left" v-if="list.hrEmpName">操 作 人：</div>
                <div class="info_right">
                  <div  v-if="list.interviewResult == 1">
                    {{list.hrEmpName}} <img src="../../../assets/user/query.png" alt="">
                  </div>
                  <div  v-if="list.interviewResult == 2">
                    {{list.hrEmpName}} <img src="../../../assets/user/no.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import api from '@/apis/inside'
export default {
  name: "HR",
  data() {
    return {
      salaryInfo: {},
      active: 0,
      inList: [],
      selfList: [],
      handleList: []
    };
  },
  created() {
    this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
  },
  mounted() {
    this.selectDeliveryRecordOther()
    this.selectDeliveryRecordSelf()
    this.selectDeliveryHandleRecord()
  },
  methods: {
    //获取内推数据
    selectDeliveryRecordOther() {
      api.selectDeliveryRecordOther({
        empNo: this.salaryInfo.empNo, // 10005466
      }).then((res) => {
        if (res.code == 200) {
          this.inList = res.data
        }
      })
    },
    //获取自荐数据
    selectDeliveryRecordSelf() {
      api.selectDeliveryRecordSelf({
        empNo: this.salaryInfo.empNo,
      }).then((res) => {
        if (res.code == 200) {
          this.selfList = res.data
        }
      })
    },
    //获取已处理数据
    selectDeliveryHandleRecord() {
      api.selectDeliveryHandleRecord({
        empNo: this.salaryInfo.empNo,
      }).then((res) => {
        if (res.code == 200) {
          this.handleList = res.data
        }
      })
    },
    //拨打电话
    callPhone(tel) {
      window.location.href = `tel:${tel}`
    },
    // 复制邮箱
    sendEmail() {
      // var input = document.createElement("input"); // 创建input对象
      // input.value = email; // 设置复制内容
      // document.body.appendChild(input); // 添加临时实例
      // input.select(); // 选择实例内容
      // document.execCommand("Copy"); // 执行复制
      // document.body.removeChild(input); // 删除临时实例
      // this.$message.success('复制成功！')
    },
    //跳转详情页
    jumpPageDetail(recordUuid,type) {
      this.$router.push({
        path: '/HR/deliverDetails',
        query: {
          recordUuid,
          type:type
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #deliveryRecord {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #deliveryRecord {
    width: 276px * $zoom;
  }
}
#deliveryRecord {
  font-size: 16px * $zoom;
  position: relative;
  .hr_container {
    width: 100%;
    min-height: 100vh;
    background: #F7F9FA;
    .hr_index {
      width: 100%;
      padding: 50px 32px;
      background: linear-gradient(180deg, #5CC385 0%, rgba(104,224,174,0) 100%);
      .hr_img {
        width: 100%;
        height: 248px;
        border-radius: 10px;
        background: #ccc;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .tab_list {
      padding: 0 32px 32px;
      .tab_item {
        width: 100%;
        // height: 528px;
        background: #fff;
        margin-top: 24px;
        padding: 30px;
        border-radius: 16px;
        position: relative;
        cursor: pointer;
        .tab_item_top {
          overflow: hidden;
          .picture {
            overflow: hidden;
            float: left;
            width: 95px;
            height: 95px;
            border-radius: 50%;
            background: #ccc;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .tite_in {
            float: left;
            margin-left: 20px;
            font-size: 32px;
            font-weight: bold;
            color: #282B32;
          }
          .text_self {
            float: left;
            margin-left: 20px;
            .tite_self {
              margin-top: 6px;
              font-size: 32px;
              font-weight: bold;
              color: #282B32;
            }
            .content {
              margin-top: 6px;
              font-size: 24px;
              color: #969B9E;
            }
          }
          .time {
            float: right;
            font-size: 24px;
            color: #666666;
            img {
              width: 16px;
              height: 28px;
            }
          }
          .time_margin_top {
            margin-top: 30px;
          }
        }
        .tab_item_line_height {
          line-height: 95px;
        }
        .tab_item_info {
          display: flex;
          margin-top: 20px;
          font-size: 30px;
          line-height: 42px;
          .info_left {
            width: 160px;
            color: #666666;
          }
          .info_right {
            color: #282B32;
            img{
              position: absolute;
              top: 100px * $zoom;
              right: 30px * $zoom;
              width: 45px * $zoom;
              height: 45px * $zoom;
            }
          }
          .setColor {
            color: #0089FF;
          }
        }
      }
    }
  }
}

::v-deep .van-tabs__nav {
  background: transparent;
  display: block;
  .van-tab {
    float: left;
    width: 160px;
    font-size: 32px;
    line-height: 66px;
    color: #969B9E;

  }
  .van-tab--active {
    font-weight: 800;
    color: #282B32;
  }
  .van-tabs__line {
    width: 48px;
    height: 8px;
    background: #4EA27C;
  }
}
</style>
